<div class="container-fluid new-hire-container">
  <div class="row">
    <div class="col">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/plans">
            {{"plan.page.title" | translate}}
          </a>
          <svg style="width: 14px;height: 14px;margin-left: 3px; fill:#212529">
            <use xlink:href="#icon-arrow-right"/>
          </svg>
          <a [routerLink]="['..']">
            {{planName}}
          </a>
        </li>
      </ol>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col page-header plan-detail">
      <wfm-page-title title="{{'plan.ct.settings.page.title'|translate}}"></wfm-page-title>
    </div>
    <div class="col text-right">

      <button id="return-to-plan" class="btn btn-secondary btn-lg no-right-margin" [routerLink]="['..']" title='{{"plan.dist.return.plan" | translate}}'>{{"plan.dist.return.plan" | translate}}</button>
      <button id="apply" (click)="applyChanges()" [ngClass]="{'disabled': _isLoading || isValidSettings==false || _isPristine || _isLoadingError}" class="btn btn-primary btn-lg no-right-margin" [disabled]="_isLoading || isValidSettings==false || _isPristine" title='{{"plan.apply.btn" | translate}}'>{{"plan.apply.btn" | translate}}</button>


    </div>
  </div>
  <div class="row toolbar-container text-left no-gutters" *ngIf="!_isLoadingError">

    <div class="vertical-align-middle">
      <span class="toolbar-label" >{{"plan.ct.settings.dropdown.label" | translate}}</span>
      <p-multiselect placeholder=" " #ctSelector
                     class="filterable ct-selector contactTypeDropDown toolbar-select no-x-scroll"
                     [(ngModel)]="selectedCTs"
                     ngDefaultControl
                     [options]="contactTypesList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     [virtualScrollItemSize]="40"
                     [virtualScrollOptions]="virtualScrollOptions"
                     scrollHeight="200px"
                     panelStyleClass="esp-multiselect-fixed-height"
                     optionLabel="value.label"
                     optionValue="value"
                     (onChange)="updateSelectedCTs($event)"
                     (onPanelShow)="ctSelectorOpened()"
                     (onPanelHide)="ctSelectorClosed()"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="_isLoading || isValidSettings==false"
                     [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                     emptyFilterMessage="{{'plan.ct.settings.cts.dropdown.empty' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">

          <!--<ng-container
            *ngTemplateOutlet="multiSelectSelectedItems;
            context: { value : value, emptyMessage:'historical-data.params.empty.selection' }">
          </ng-container>-->
          <esp-multi-select-content [items]="value" emptyMessage="plan.ct.settings.cts.dropdown.empty.selection"> </esp-multi-select-content>

        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="ctSelector">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="ctSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <esp-multi-select-item [item]="item"></esp-multi-select-item>
        </ng-template>
      </p-multiselect>
      <div class="embedded-info borderless" *ngIf="_displayMultiSelectWarning">
        <i class="icon-info"></i>
        {{"plan.ct.settings.multi.ct.warning" | translate}}
      </div>
    </div>
    <div class="text-right">
      <breeze-button buttonText="{{'plan.ct.settings.discard.btn'|translate}}"
                     id="discard-btn"
                     [isDisabled]=_isPristine
                     [isSecondary]="true"
                     (clicked)="showDiscardDlg()">

      </breeze-button>
    </div>
  </div>
  <sol-tabs *ngIf="!_isLoadingError">
    <sol-tab title="{{'plan.ct.settings.operating.hours'|translate}}">
      <esp-operating-hours [operatingHours]="mergedCtSettings?.operatingHours" *ngIf="displayTabData" (modelChanged)="onOperatingHoursChange($event)">

      </esp-operating-hours>
      <div *ngIf="!displayTabData && !_isLoading" class="no-op-hrs">
        <wfm-esp-no-rows-overlay [params]="opHrsOverlayMsg"></wfm-esp-no-rows-overlay>
      </div>
    </sol-tab>
    <sol-tab title="{{'plan.ct.settings.fte.settings'|translate}}">
      <esp-fte-settings [ctSettings]="mergedCtSettings" (modelChanged)="onFteSettingsChange($event)" *ngIf="displayTabData"></esp-fte-settings>
      <div *ngIf="!displayTabData && !_isLoading" class="no-fte-settings">
        <wfm-esp-no-rows-overlay [params]="fteSettingsOverlayMsg"></wfm-esp-no-rows-overlay>
      </div>
    </sol-tab>
    <sol-tab title="{{'plan.ct.settings.additional.settings'|translate}}" minWidth="190">
      @if(displayTabData && !_isLoading){
        <esp-miscellaneous [ctSettings]="mergedCtSettings" (modelChanged)="onMiscChange($event)"></esp-miscellaneous>
      }@else{
        <div class="no-op-hrs">
          <wfm-esp-no-rows-overlay [params]="miscSettingsOverlayMsg"></wfm-esp-no-rows-overlay>
        </div>
      }
    </sol-tab>

  </sol-tabs>
  <div class="loading-error" *ngIf="_isLoadingError">
    <span class="err-msg">
      {{"plan.ct.settings.loading.error.msg"|translate}}
    </span>
  </div>
</div>
<div class="overlay-panel" *ngIf="_isLoading">
  <wfm-esp-loading-rows-overlay></wfm-esp-loading-rows-overlay>
</div>
<wfm-task-progress [task]="task" *ngIf="task && planDetails" [canCancel]="false">

</wfm-task-progress>
<p-toast position="bottom-right" [baseZIndex]="50">
</p-toast>
